import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  background: #2253f5;
  height: 80px;

  ul {
    list-style: none;
  }

  .navbar {
    background: #2253f5;
    width: 100%;
    height: 77px;
    position: fixed;
    z-index: 10;
  }

  .navbar_active {
    opacity: 1;
    transform: translateY(0px);
    transition: opacity 0.5s ease, transform 0.5s ease, visibility 0.5s;
  }

  .navbar_inactive {
    opacity: 0;
    transform: translateY(-102px);
    transition: opacity 0.5s ease, transform 0.5s ease, visibility 0.5s;
  }

  .has_shadow {
    box-shadow: 0px 3px 14px rgb(0 0 0 / 8%);
  }

  nav {
    max-width: 1300px;
    margin: 0 auto;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .container-nav {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0.8rem;

      .cloud {
        width: 150px;
        margin-bottom: 0.4rem;
        margin-left: 1.1rem;
      }

      .menu {
        position: absolute;
        top: 33px;
        left: 167px;
        opacity: 0;
        visibility: hidden;
        transform: translateY(-20px);
        transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
      }

      .flag {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 2rem;
        margin-right: -0.5rem;
      }

      .flag-blog {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 2rem;
        margin-right: 2.2rem;
        height: 100%;
      }

      .menu.active {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
      }

      button {
        background: none;
        border: none;
        margin-left: 1rem;
        cursor: pointer;
      }

      .button-active {
        transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
        transform: rotateZ(180deg);
      }
      .button-inactive {
        transition: opacity 0.4s ease, transform 0.4s ease, visibility 0.4s;
      }
    }
    .links {
      *:not(:last-child) {
        margin-right: 1.8rem;
      }

      ul {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: -0.3rem;

        font-family: Montserrat;
        font-size: 16px;

        color: white;
        li {
          a {
            text-decoration: none;
            color: white;
          }

          &.active {
            font-weight: bold;
            border-bottom: 2px solid #7be8ff;
          }
        }
      }
    }
  }

  .buttonsNav {
    font-family: Montserrat;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.3rem;
    margin-right: 1.1rem;
    .loginNav {
      text-decoration: none;
      color: #fcff7c;
      font-weight: bold;
      font-size: 1rem;

      transition: filter 0.2s ease-in;

      &:hover {
        filter: brightness(0.9);
      }
    }

    .cadastroNav {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      width: 16.875rem;
      height: 40px;
      margin-right: 1.875rem;
      margin-left: 1.875rem;
      text-decoration: none;
      background: #fcff7c;
      color: #2253f5;
      border-radius: 100px;
      font-weight: bold;
      font-size: 16px;
      transition: filter 0.2s ease-in;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }

  @media (max-width: 768px) {
    .buttonsNav {
      display: none;
    }
    .navbar {
      height: 80px;
    }
    nav {
      margin-top: 0.1rem;
      flex-wrap: wrap;

      .cloud {
        width: 80%;
      }

      .flag,
      .flag-blog {
        display: none;
      }

      button {
        display: none;
      }
      .links {
        margin-right: 0.5rem;
        width: unset;
        *:not(:last-child) {
          margin-right: 10px;
        }
        ul {
          li {
            padding: 6px 10px;
            font-size: 14px;
          }
        }

        .buttonsNav {
          li:first-child > a {
            display: none;
          }
        }
      }
    }

    button {
      height: 30px;
      width: 60px;
      font-size: 14px;
    }
  }
`;
